<template>
    <div></div>
</template>

<script>

  const TawkChatMaker = function(srcLink) {
    let Tawk_API = {}
    let Tawk_LoadStart = new Date()
    let s1 = document.createElement("script")
    let s0 = document.getElementsByTagName("script")[0]
    s1.setAttribute('id', 'vuetawk')
    s1.async = true
    s1.src = srcLink
    s1.charset = 'UTF-8'
    s1.setAttribute('crossorigin', '*')
    s0.parentNode.insertBefore(s1, s0)
    window.Tawk_API = Tawk_API
  };

  function Tawk() {

    return {
      init(src) {
        if(!window.Tawk_API) {
          TawkChatMaker(src)
        } else {
          window.Tawk_API.showWidget();
        }
      },
      updateUser(user) {
        if (!user) return
        window.Tawk_API.onLoad = function(){
          window.Tawk_API.setAttributes(user, function (error) {
            console.log(error)
          });
        }
      },

      closeChat(){
        window.Tawk_API.hideWidget();
      }
    }
  }

  const TawkInstance = new Tawk()


  export default {
    name: 'TawktoEnabler',

    mounted() {
      TawkInstance.init(window.tawkto_src);
      TawkInstance.updateUser({
        name: this.$page.props.auth.user.first_name + ' ' + this.$page.props.auth.user.last_name,
        email: this.$page.props.auth.user.email,
        mobile: this.$page.props.auth.user.mobile,
        shops: this.$page.props.tawk_attributes.shops,
      });

    },

    beforeDestroy() {
      TawkInstance.closeChat()
    }
  }
</script>
